import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';

const ButtonBlack = props => (
  <TouchableOpacity onPress={props.onPress}>
  <View style={styles.button}>
  <Text style={styles.buttonText}>{props.text}</Text>
  </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
 button: {
  paddingVertical: 14,
  marginTop:20,
  width:155,
  backgroundColor: 'black',
  borderStyle: 'solid',
  height:48,
  borderColor: "black",
  borderWidth: 1
  },
buttonText: {
  color:"white",
  textAlign: "center",
  fontWeight:"800"
  }
});

export default ButtonBlack;